import { Box, Flex, Image, Stack, StackDirection } from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import Link from 'next/link'
import { FC, useMemo } from 'react'

import ArrowRightOmens from '../svg/ArrowRightOmens'
import { Body1, H3, H4 } from '../typography'

interface CoursesSectionProps {
  reverse?: boolean
}

const CoursesSection: FC<CoursesSectionProps> = ({ reverse = false }) => {
  const courseData = useMemo(() => {
    const data = [
      {
        title: 'Programa Master',
        description: 'Terapia intensiva para controle da ereção',
        imgSrc: '/academy/joao_master_program.webp',
        link: '/cursos/programa-master'
      },
      {
        title: 'Programa Control',
        description: 'Terapia intensiva para controle da ejaculação',
        imgSrc: '/academy/joao_control_program.webp',
        link: '/cursos/programa-control'
      }
    ]

    if (reverse) {
      return data.reverse()
    }

    return data
  }, [reverse])

  return (
    <Box bg="alabaster" py={{ base: '40px', lg: '96px' }}>
      <LandingContainer gap={{ base: '24px', lg: '36px' }}>
        <Stack maxW="640px">
          <H3>Potencialize a sua performance com os nossos cursos</H3>
        </Stack>

        <Stack direction={{ base: 'column', lg: 'row' }} gap={{ base: '20px', lg: '24px' }}>
          {courseData.map((item, index) => (
            <CourseCard {...item} {...{ index }} key={index} />
          ))}
        </Stack>
      </LandingContainer>
    </Box>
  )
}

export default CoursesSection

interface CourseCardProps {
  title: string
  description: string
  imgSrc: string
  link: string
  index: number
  bg?: string
}

const CourseCard: FC<CourseCardProps> = ({ title, description, imgSrc, link, index, ...props }) => {
  const direction: StackDirection = { base: 'column', lg: index % 2 === 0 ? 'column' : 'column-reverse' }

  return (
    <Stack direction={direction} gap={{ base: '20px', lg: '24px' }}>
      <Image
        loading="lazy"
        objectFit="cover"
        src={imgSrc}
        alt={title}
        h={{ base: '280px', lg: '364px' }}
        borderRadius={{ base: '24px', lg: '40px' }}
      />

      <Link prefetch={false} href={link} passHref>
        <Stack
          bg={index % 2 === 0 ? 'grayscale.20' : 'dandelion'}
          borderRadius={{ base: '24px', lg: '40px' }}
          p={{ base: '24px', lg: '36px' }}
          gap={{ base: '48px', lg: '70px' }}
        >
          <Flex alignItems="center">
            <H4>{title}</H4> <ArrowRightOmens fill="phthalo" boxSize="30px" ml={3} />
          </Flex>

          <Body1 maxW="200px">{description}</Body1>
        </Stack>
      </Link>
    </Stack>
  )
}
